import {Injectable} from '@angular/core';

import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {SystemSettingsRequestItem} from '../models/system-settings/system-settings-request-item';
import {AuthService} from './auth.service';
import {BaseService} from '../../../services/base.service';

@Injectable({
    providedIn: 'root'
})
export class SystemSettingsService extends BaseService {

    httpOptions;

    constructor(private authService: AuthService, private httpClient: HttpClient) {
        super();

        this.httpOptions = authService.getHttpOptions();
    }

    public getConfigValue(settingList, configId) {
        for (let i = 0; i < settingList.length; i++) {
            if (settingList[i].config_id === configId) {
                return settingList[i].value;
            }

        }
        return '';
    }


    public getSettingsObj(name, value, module) {

        return {
            'config_id': name,
            'value': value,
            'module': module
        };

    }

    // get setting module
    public getSettingModule(module: string): Observable<SystemSettingsRequestItem[]> {

        return this.httpClient.get(`${this.apiURL}/settings/get/` + module, {headers: this.authService.getHttpOptions()}).map((res: SystemSettingsRequestItem[]) => res);

    }

    // add/update system setting by id
    public updateSetting(items: any, storeview: any = 'base') {

        let obj = {
            settings: {items: items},
            storeview: storeview
        }
        return this.httpClient.post(`${this.apiURL}/settings/set`, obj, {headers: this.authService.getHttpOptions()});

    }

    getPublicSettings(store_view = 'base'): Observable<any[]> {


        let obj = {
            storeview: this.storeview
        }

        return this.httpClient.post<any[]>(`${this.apiURL}/settings/public/get`, obj, {headers: this.authService.getHttpOptions()});
    }


    getSettings(store_view = 'base'): Observable<any[]> {

        let obj = {
            store_view: store_view
        }

        return this.httpClient.post<any[]>(`${this.apiURL}/settings/get`, obj, {headers: this.authService.getHttpOptions()});
    }


}
